/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutItemsDialog extends _Ext.ItemEditorDialog<ApprovalOutItemsRow> {
        protected getFormKey() { return ApprovalOutItemsForm.formKey; }
        protected getLocalTextPrefix() { return ApprovalOutItemsRow.localTextPrefix; }
        protected getDeletePermission() { return ApprovalOutItemsRow.deletePermission; }
        protected getInsertPermission() { return ApprovalOutItemsRow.insertPermission; }
        protected getUpdatePermission() { return ApprovalOutItemsRow.updatePermission; }

        public form = new ApprovalOutItemsForm(this.idPrefix);

        // #region Public Variables
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        // #endregion

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            q.hideEditorToolbar(this.form.BOMDetails);
            q.setTextRightAlign(this.form.MF);
            q.setTextRightAlign(this.form.MFAmount);

            this.form.Pieces.changeSelect2(e => {
                let pieces = this.form.Pieces.value;
                let stockdetails = StockHelper.GetStockDetails(this.entity);
                if (stockdetails.Pieces > pieces) {

                    this.CalculateTotals();
                    this.CalculateRate();
                } else {
                    q.alert('', 'Insufficient Stock', true, 2999);
                    this.form.Pieces.value = stockdetails.Pieces; 
                }
            });

            this.form.Weight.changeSelect2(e => {
                let weight = this.form.Weight.value
                if (!isNaN(weight)) {
                    let stockdetails = StockHelper.GetStockDetails(this.entity);
                    if (stockdetails.Weight > weight) {

                        var lbr = this.form.LaborDetails.getItems();
                        var self = this;
                        lbr.forEach(function (x) {
                            x.Weight = self.form.Weight.value;
                            x.Pieces = self.form.Pieces.value;
                            x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                        });

                        this.form.LaborDetails.setItems(lbr);
                        this.CalculateRate();
                    } else {
                        q.alert('', 'Insufficient Stock', true, 2999);
                        this.form.Weight.value = stockdetails.Weight;
                    }
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });

            this.form.MF.changeSelect2(e => {
                var mf = this.form.MF.value;
                if (mf > 0) {
                    var item = RateHelper.ReCalculateMarkUp(this.form.MF.value, this.form.MFAmount.value, this.form.BOMDetails.getItems(), this.form.LaborDetails.getItems(), this.form.Pieces.value, this.form.Weight.value, this.form.NetWeight.value
                        , this.form.FancyCharges.value, this.form.OtherCharges.value);
                    var bomdetails = item.BOMDetails;
                    this.form.BOMDetails.setItems(bomdetails);
                    this.form.LaborDetails.setItems(item.LaborDetails);
                    this.CalculateTotals();
                }
            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });


        }

        getItem() {
            return this.getSaveEntity();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.ItemMaster = (this.parentEditor.parentDialog as ApprovalOutDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.PartyId = parseInt(this.ItemMaster.form.PartyId.value);
            this.TransDate = this.ItemMaster.entity.TransDate;
            this.form.StoneRate.value = this.form.StoneRate.value == null ? 0 : this.form.StoneRate.value;
            ItemFieldHelper.SalesItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
        }

    }
}